module.exports = __webpack_public_path__ + "static/media/crx.9fc58394.png";